import { ReactComponent as MaLogo } from './assets/maLogo.svg';

type SVGType = React.FC<React.SVGProps<SVGSVGElement>>;

const Icons: Record<string, SVGType> = { MaLogo };

export default Icons;
